// This file can be replaced during build by using the `fileReplacements` array.
// `vite build --mode production` uses `.env.production` file.
// The list of file replacements can be found in `vite.config.ts`.

const apiBase = import.meta.env.VITE_API_URL;
const adminBase = import.meta.env.VITE_API_URL;

export const environment = {
  production: import.meta.env.PROD,
  admin: adminBase,
  settingsId: import.meta.env.VITE_SETTINGS_ID || "61585eb12658d84b7026def4",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

export default environment;
